import axios from 'axios'
const { ADMIN_API_URL } = process.env

const adminRequest = axios.create({
  baseURL: ADMIN_API_URL || 'http://0.0.0.0:8000',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// Add a request interceptor to include auth token
adminRequest.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token')

    // admin-node's verifyToken middleware feeds the entire
    // Authorization header straight into jwt.verify() — no Bearer
    // stripping. Send the raw token to match what initializeApp()
    // sets as the default header on every admin-side axios client.
    if (token) {
      config.headers.Authorization = token
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default adminRequest
